import { EMPTY_OBJECT, EMPTY_STRING } from '../../../../constants/common'
import { ControlText } from '../ControlText'

import { control } from './control'

/**
 * @param {string} name
 * @param {string} value
 * @param {Object} defaultProps
 */
export function text(name, value = EMPTY_STRING, defaultProps = EMPTY_OBJECT) {
  return control(name, value, ControlText, defaultProps)
}
